export const PermissionNumbers = Object.freeze({
  SPID: 1072,
  DELETE_RECEIVER: 1028,
  BULK_PERMISSIONS: 1071,
  INTERNATIONAL_RECEIVER: 1024,
  CEDES_PERMISSION: 1042,
  CEDES_CERTIFICADO_DEPOSITO: 1081,
  PAYMENTS: 1064,
  NATIONAL_PAYMENTS: 1023,
  INTERNATIONAL_PAYMENTS: 1024,
  RECEIVERS: 1020,
  ADD_RECEIVERS: 1032
})
